import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import ZPLRenderer from './ZPLRender'

import {
  AlertCircle, Barcode, CalendarClock, Camera, ChevronDown,
  ChevronFirst, ChevronLast, ChevronLeft, ChevronRight,
  ClipboardCheck, Clock, Copy, Download, Eye, Filter,
  Image as ImageIcon, MapPin, Package, PackageOpen,
  PackageSearch, Printer, Receipt, RefreshCw, Search,
  Store, Tag, TrendingUp, Truck, User, X, CheckCircle2,
  Hash, BarChart2, FileText,
} from 'lucide-react'

/* ─── Estilos globais estilo Tiny ERP ────────────────────────────────────── */
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

    .od * { font-family: 'Inter', system-ui, sans-serif !important; box-sizing: border-box; }

    .od {
      background: #f0f2f5;
      min-height: 100vh;
      padding-bottom: 48px;
    }

    /* ── Cabeçalho da página ── */
    .od-header {
      background: #fff;
      border-bottom: 1px solid #dde1e7;
      padding: 14px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
      position: sticky;
      top: 0;
      z-index: 10;
      box-shadow: 0 1px 4px rgba(0,0,0,.05);
    }
    .od-header-left { display: flex; align-items: center; gap: 12px; }
    .od-header-icon {
      width: 38px; height: 38px; border-radius: 8px;
      background: #eff6ff; border: 1px solid #bfdbfe;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0;
    }
    .od-header-title {
      font-size: 16px; font-weight: 700; color: #111827; margin: 0;
      display: flex; align-items: center; gap: 8px;
    }
    .od-header-sub { font-size: 11px; color: #6b7280; margin-top: 2px; }
    .od-header-right { display: flex; align-items: center; gap: 8px; }

    /* ── Botão principal (azul) ── */
    .od-btn-primary {
      display: inline-flex; align-items: center; gap: 6px;
      font-size: 12px; font-weight: 600; padding: 7px 14px;
      background: #2563eb; color: #fff; border: none; border-radius: 6px;
      cursor: pointer; transition: background .12s;
    }
    .od-btn-primary:hover { background: #1d4ed8; }

    /* ── Botão secundário ── */
    .od-btn-sec {
      display: inline-flex; align-items: center; gap: 6px;
      font-size: 12px; font-weight: 500; padding: 6px 12px;
      background: #fff; color: #374151;
      border: 1px solid #d1d5db; border-radius: 6px;
      cursor: pointer; transition: all .12s;
    }
    .od-btn-sec:hover { background: #f3f4f6; }

    /* ── Botão ícone pequeno ── */
    .od-icon-btn {
      display: inline-flex; align-items: center; justify-content: center;
      width: 24px; height: 24px; border-radius: 4px;
      border: none; background: transparent; color: #9ca3af;
      cursor: pointer; transition: all .12s; padding: 0;
    }
    .od-icon-btn:hover { background: #eff6ff; color: #2563eb; }

    /* ── Layout principal ── */
    .od-body { max-width: 1280px; margin: 0 auto; padding: 20px 24px; }

    /* ── Cards de KPI ── */
    .od-kpi-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 12px;
      margin-bottom: 20px;
    }
    @media (max-width: 1024px) { .od-kpi-grid { grid-template-columns: repeat(3, 1fr); } }
    @media (max-width: 640px)  { .od-kpi-grid { grid-template-columns: repeat(2, 1fr); } }

    .od-kpi {
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 14px 16px;
      display: flex;
      align-items: flex-start;
      gap: 12px;
      box-shadow: 0 1px 3px rgba(0,0,0,.04);
    }
    .od-kpi-icon {
      width: 36px; height: 36px; border-radius: 8px;
      display: flex; align-items: center; justify-content: center; flex-shrink: 0;
    }
    .od-kpi-label { font-size: 11px; font-weight: 500; color: #6b7280; margin-bottom: 3px; }
    .od-kpi-value { font-size: 15px; font-weight: 700; color: #111827; line-height: 1.2; }

    /* ── Timeline de status ── */
    .od-timeline-card {
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 18px 24px;
      margin-bottom: 20px;
      box-shadow: 0 1px 3px rgba(0,0,0,.04);
    }
    .od-timeline-wrap {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0;
      overflow-x: auto;
      padding: 4px 0;
    }
    .od-tl-step {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      min-width: 80px;
    }
    .od-tl-circle {
      width: 36px; height: 36px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      border: 2px solid #e5e7eb; background: #f9fafb; color: #9ca3af;
      transition: all .2s;
    }
    .od-tl-circle.active {
      border-color: #2563eb; background: #eff6ff; color: #2563eb;
    }
    .od-tl-circle.done {
      border-color: #16a34a; background: #f0fdf4; color: #16a34a;
    }
    .od-tl-label {
      font-size: 10px; font-weight: 500; color: #9ca3af; text-align: center; max-width: 72px;
    }
    .od-tl-label.active { color: #2563eb; font-weight: 600; }
    .od-tl-label.done  { color: #16a34a; font-weight: 600; }
    .od-tl-line {
      width: 48px; height: 2px; background: #e5e7eb; margin-bottom: 22px; flex-shrink: 0;
    }
    .od-tl-line.done { background: #16a34a; }
    .od-tl-line.active { background: #2563eb; }

    /* ── Layout de duas colunas ── */
    .od-main-grid {
      display: grid;
      grid-template-columns: 1fr 300px;
      gap: 16px;
      align-items: start;
    }
    @media (max-width: 1024px) { .od-main-grid { grid-template-columns: 1fr; } }

    /* ── Card genérico ── */
    .od-card {
      background: #fff;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 1px 3px rgba(0,0,0,.04);
      margin-bottom: 16px;
    }
    .od-card-header {
      display: flex; align-items: center; justify-content: space-between;
      padding: 12px 16px;
      border-bottom: 1px solid #f3f4f6;
      background: #f8f9fb;
      gap: 8px;
    }
    .od-card-title {
      font-size: 13px; font-weight: 600; color: #111827;
      display: flex; align-items: center; gap: 6px; margin: 0;
    }
    .od-card-body { padding: 16px; }

    /* ── Barra de filtros ── */
    .od-filter-bar {
      display: flex; gap: 8px; flex-wrap: wrap; align-items: center;
    }
    .od-search-wrap { position: relative; flex: 1; min-width: 160px; }
    .od-search-wrap svg { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); color: #9ca3af; pointer-events: none; }
    .od-input {
      width: 100%; padding: 7px 10px 7px 32px;
      font-size: 12px; border: 1px solid #d1d5db; border-radius: 6px;
      color: #374151; background: #fff; outline: none; transition: border .12s;
    }
    .od-input:focus { border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.1); }
    .od-input-sm { padding: 7px 10px; min-width: 90px; max-width: 110px; }
    .od-select {
      padding: 7px 10px; font-size: 12px; border: 1px solid #d1d5db;
      border-radius: 6px; color: #374151; background: #fff; outline: none; cursor: pointer;
    }
    .od-select:focus { border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.1); }

    /* ── Tabela de itens ── */
    .od-table { width: 100%; border-collapse: collapse; font-size: 12px; }
    .od-table thead tr { background: #f3f4f6; }
    .od-table thead th {
      padding: 9px 14px;
      text-align: left;
      font-size: 10px; font-weight: 600; color: #6b7280;
      text-transform: uppercase; letter-spacing: .05em;
      border-bottom: 2px solid #e5e7eb; white-space: nowrap;
    }
    .od-table thead th.right { text-align: right; }
    .od-table thead th.center { text-align: center; }
    .od-table tbody tr { border-bottom: 1px solid #f3f4f6; transition: background .1s; }
    .od-table tbody tr:last-child { border-bottom: none; }
    .od-table tbody tr:hover { background: #f5f7ff; }
    .od-table tbody tr.kit-row { background: #f0f7ff; }
    .od-table tbody tr.kit-row:hover { background: #e8f2ff; }
    .od-table td { padding: 9px 14px; vertical-align: middle; color: #374151; }
    .od-table td.right { text-align: right; }
    .od-table td.center { text-align: center; }
    .od-table tfoot tr { background: #f8f9fb; border-top: 2px solid #e5e7eb; }
    .od-table tfoot td { padding: 10px 14px; font-weight: 600; font-size: 12px; color: #111827; }

    /* ── Badges ── */
    .ob { display: inline-flex; align-items: center; gap: 3px; font-size: 10px; font-weight: 600; padding: 2px 7px; border-radius: 3px; white-space: nowrap; }
    .ob-blue   { background: #dbeafe; color: #1e40af; }
    .ob-green  { background: #dcfce7; color: #166534; }
    .ob-yellow { background: #fef9c3; color: #854d0e; }
    .ob-orange { background: #ffedd5; color: #9a3412; }
    .ob-gray   { background: #f3f4f6; color: #374151; border: 1px solid #e5e7eb; }
    .ob-teal   { background: #ccfbf1; color: #115e59; }
    .ob-red    { background: #fee2e2; color: #991b1b; }

    /* ── Status pill no header ── */
    .od-status-pill {
      display: inline-flex; align-items: center; gap: 6px;
      font-size: 12px; font-weight: 600; padding: 5px 12px;
      border-radius: 20px; border: 1px solid;
    }

    /* ── SKU mono ── */
    .od-sku { font-family: 'Courier New', monospace !important; font-size: 11px; font-weight: 600; color: #1e40af; }

    /* ── Paginação ── */
    .od-pagination { display: flex; align-items: center; justify-content: space-between; padding: 10px 14px; border-top: 1px solid #f3f4f6; background: #fafafa; font-size: 12px; color: #6b7280; flex-wrap: wrap; gap: 8px; }
    .od-pag-btns { display: flex; gap: 2px; }
    .od-pag-btn { width: 28px; height: 28px; border-radius: 5px; border: 1px solid #e5e7eb; background: #fff; color: #6b7280; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: all .1s; }
    .od-pag-btn:hover:not(:disabled) { background: #eff6ff; color: #2563eb; border-color: #2563eb; }
    .od-pag-btn:disabled { opacity: .4; cursor: not-allowed; }

    /* ── Painel lateral de info ── */
    .od-info-row { display: flex; justify-content: space-between; align-items: flex-start; padding: 9px 0; border-bottom: 1px solid #f3f4f6; gap: 8px; }
    .od-info-row:last-child { border-bottom: none; }
    .od-info-label { font-size: 11px; font-weight: 500; color: #6b7280; white-space: nowrap; }
    .od-info-value { font-size: 12px; font-weight: 500; color: #111827; text-align: right; display: flex; align-items: center; gap: 4px; }
    .od-info-value.mono { font-family: 'Courier New', monospace !important; font-size: 11px; }

    /* ── Galeria de fotos ── */
    .od-photo-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(90px, 1fr)); gap: 8px; }
    .od-photo-thumb {
      aspect-ratio: 1; border-radius: 6px; overflow: hidden;
      border: 1px solid #e5e7eb; cursor: pointer; position: relative;
      transition: all .15s;
    }
    .od-photo-thumb:hover { border-color: #2563eb; box-shadow: 0 0 0 2px rgba(37,99,235,.2); transform: translateY(-1px); }
    .od-photo-thumb img { width: 100%; height: 100%; object-fit: cover; }
    .od-photo-overlay {
      position: absolute; inset: 0; background: rgba(0,0,0,0); display: flex;
      align-items: center; justify-content: center; transition: background .15s;
    }
    .od-photo-thumb:hover .od-photo-overlay { background: rgba(37,99,235,.35); }
    .od-photo-num { position: absolute; top: 4px; left: 4px; background: rgba(0,0,0,.5); color: #fff; font-size: 9px; font-weight: 600; padding: 1px 5px; border-radius: 3px; }

    /* ── Carousel modal ── */
    .od-modal-overlay { position: fixed; inset: 0; z-index: 1000; background: rgba(0,0,0,.85); display: flex; align-items: center; justify-content: center; }
    .od-modal-close { position: absolute; top: 16px; right: 16px; width: 36px; height: 36px; border-radius: 50%; background: rgba(255,255,255,.15); border: none; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: background .12s; }
    .od-modal-close:hover { background: rgba(255,255,255,.3); }
    .od-modal-nav { position: absolute; top: 50%; transform: translateY(-50%); width: 40px; height: 40px; border-radius: 50%; background: rgba(255,255,255,.15); border: none; color: #fff; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: background .12s; }
    .od-modal-nav:hover { background: rgba(255,255,255,.3); }
    .od-modal-nav.left { left: 16px; }
    .od-modal-nav.right { right: 16px; }
    .od-modal-counter { position: absolute; bottom: 16px; left: 50%; transform: translateX(-50%); background: rgba(0,0,0,.5); color: #fff; font-size: 12px; font-weight: 500; padding: 4px 12px; border-radius: 20px; }

    /* ── ZPL Modal ── */
    .od-zpl-modal { background: #fff; border-radius: 10px; max-width: 560px; width: 100%; margin: 0 16px; overflow: hidden; }
    .od-zpl-header { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; border-bottom: 1px solid #e5e7eb; background: #f8f9fb; }
    .od-zpl-header h3 { font-size: 14px; font-weight: 600; color: #111827; margin: 0; }
    .od-zpl-body { padding: 18px; max-height: 70vh; overflow-y: auto; }
    .od-zpl-footer { display: flex; justify-content: flex-end; gap: 8px; padding: 12px 18px; border-top: 1px solid #e5e7eb; background: #f8f9fb; }

    /* ── Toast ── */
    .od-toast {
      position: fixed; bottom: 20px; right: 20px; z-index: 2000;
      display: flex; align-items: center; gap: 8px;
      padding: 10px 16px; border-radius: 8px; font-size: 13px; font-weight: 500;
      box-shadow: 0 4px 16px rgba(0,0,0,.15);
      animation: od-toast-in .2s ease;
    }
    @keyframes od-toast-in { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
    .od-toast.success { background: #16a34a; color: #fff; }
    .od-toast.danger  { background: #dc2626; color: #fff; }
    .od-toast.info    { background: #2563eb; color: #fff; }

    /* ── Erro ── */
    .od-error { background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 12px 16px; display: flex; align-items: center; gap: 8px; font-size: 13px; color: #991b1b; margin-bottom: 16px; }

    /* ── Empty state ── */
    .od-empty { display: flex; flex-direction: column; align-items: center; padding: 40px 20px; color: #9ca3af; gap: 8px; }
    .od-empty p { font-size: 13px; }

    /* ── Loading ── */
    .od-spin { width: 28px; height: 28px; border: 2px solid #e5e7eb; border-top-color: #2563eb; border-radius: 50%; animation: od-spin .7s linear infinite; }
    @keyframes od-spin { to { transform: rotate(360deg); } }
    .od-loading-wrap { display: flex; flex-direction: column; align-items: center; gap: 12px; padding: 50px; color: #9ca3af; font-size: 13px; }

    @media (max-width: 640px) {
      .od-body { padding: 12px; }
      .od-header { padding: 10px 14px; }
      .od-kpi-grid { grid-template-columns: repeat(2, 1fr); }
    }
  `}</style>
)

/* ─── Status meta ─────────────────────────────────────────────────────────── */
const STATUS_STEPS = [
  { label: 'Aguardando', icon: AlertCircle },
  { label: 'Em Processamento', icon: Clock },
  { label: 'Enviado', icon: Truck },
  { label: 'Entregue', icon: ClipboardCheck },
]

const getStatusStep = (status) => ({
  'Aguardando Pagamento': 0, 'Em Processamento': 1,
  Enviado: 2, Entregue: 3, Atendido: 3,
}[status] ?? 0)

const getStatusPillStyle = (status) => ({
  'Aguardando Pagamento': { bg: '#fffbeb', color: '#b45309', border: '#fde68a' },
  'Em Processamento':     { bg: '#eff6ff', color: '#1d4ed8', border: '#bfdbfe' },
  Enviado:                { bg: '#f0fdf4', color: '#166534', border: '#bbf7d0' },
  Entregue:               { bg: '#f0fdf4', color: '#166534', border: '#bbf7d0' },
  Atendido:               { bg: '#f0fdf4', color: '#166534', border: '#bbf7d0' },
}[status] || { bg: '#f3f4f6', color: '#374151', border: '#e5e7eb' })

/* ─── Componente principal ───────────────────────────────────────────────── */
const OrderDetails = () => {
  const { idpedido, id_conta } = useParams()

  const [orderData, setOrderData] = useState({})
  const [showCarousel, setShowCarousel] = useState(false)
  const [carouselIndex, setCarouselIndex] = useState(0)
  const [zpl, setZpl] = useState([])
  const [fotos, setFotos] = useState([])
  const [isLoadingOrderData, setIsLoadingOrderData] = useState(false)
  const [isLoadingFotos, setIsLoadingFotos] = useState(false)
  const [showModalZpl, setShowModalZpl] = useState(false)
  const [openKits, setOpenKits] = useState({})
  const [error, setError] = useState(null)

  const [search, setSearch] = useState('')
  const [minQty, setMinQty] = useState('')
  const [sortBy, setSortBy] = useState('produto')
  const [sortDir, setSortDir] = useState('asc')
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [page, setPage] = useState(1)

  const [toast, setToast] = useState({ show: false, msg: '', variant: 'success' })
  const searchRef = useRef(null)

  /* ── Teclado ── */
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') { setShowCarousel(false); setShowModalZpl(false) } }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [])

  /* ── Fotos ── */
  const fetchFotos = useCallback(async () => {
    setIsLoadingFotos(true)
    try {
      const r = await apinode.get(`/pedido/foto/${idpedido}/${id_conta}`, { auth: { username: 'admin', password: 'admin' } })
      const primary = Array.isArray(r.data) ? r.data : []
      if (primary.length > 0) { setFotos(primary) }
      else {
        const fb = await apinode.get(`/foto/fotos/${idpedido}/${id_conta}`)
        setFotos(Array.isArray(fb.data) ? fb.data : [])
      }
    } catch { setError('Falha ao carregar fotos.') }
    finally { setIsLoadingFotos(false) }
  }, [idpedido, id_conta])

  /* ── Dados do pedido ── */
  const fetchOrderData = useCallback(async () => {
    setIsLoadingOrderData(true)
    setError(null)
    try {
      const r = await apinode.get(`/orderdetails/${idpedido}/${id_conta}`)
      setOrderData(r.data)
      fetchFotos()
      const zplR = await apinode.get(`/pedido/foto/${idpedido}/${id_conta}`, { auth: { username: 'admin', password: 'admin' } })
      setZpl(zplR.data)
    } catch { setError('Não foi possível carregar os dados do pedido.') }
    finally { setIsLoadingOrderData(false) }
  }, [idpedido, id_conta, fetchFotos])

  useEffect(() => { fetchOrderData() }, [fetchOrderData])

  /* ── Helpers ── */
  const currencyBRL = (n) => typeof n === 'number' ? n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
  const fmtDateTime = (d) => d ? new Date(d).toLocaleString('pt-BR') : '—'
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString('pt-BR') : '—'
  const fmtTime = (d) => d ? new Date(d).toLocaleTimeString('pt-BR') : '—'

  const showToast = (msg, variant = 'success') => {
    setToast({ show: true, msg, variant })
    setTimeout(() => setToast({ show: false, msg: '', variant: 'success' }), 3000)
  }

  const copy = async (text, label = 'Copiado!') => {
    try { await navigator.clipboard.writeText(String(text)); showToast(label) }
    catch { showToast('Falha ao copiar.', 'danger') }
  }

  const toggleKit = (id) => setOpenKits((p) => ({ ...p, [id]: !p[id] }))

  /* ── Dados derivados ── */
  const { pedido_int = [], itempedido = [], desagrupado_int = [], conferidos = [] } = orderData
  const pedido = pedido_int[0] || {}

  const totals = useMemo(() => ({
    totalQtd: itempedido.reduce((a, i) => a + (Number(i.QUANTIDADE_NOVA) || 0), 0),
    totalVlr: itempedido.reduce((a, i) => a + (Number(i.VALOR_NOVO) || 0), 0),
  }), [itempedido])

  const kitItemsByRef = useMemo(() => {
    const map = {}
    for (const k of desagrupado_int) {
      if (!map[k.REFERENCIA_ID]) map[k.REFERENCIA_ID] = []
      map[k.REFERENCIA_ID].push(k)
    }
    return map
  }, [desagrupado_int])

  const filteredSorted = useMemo(() => {
    const term = search.trim().toLowerCase()
    let rows = itempedido.filter((it) => {
      const okTerm = !term || String(it.CODIGO).toLowerCase().includes(term) || String(it.DESCRICAO ?? '').toLowerCase().includes(term)
      const okQty = !minQty || Number(it.QUANTIDADE_NOVA || 0) >= Number(minQty)
      return okTerm && okQty
    })
    const dir = sortDir === 'asc' ? 1 : -1
    rows.sort((a, b) => {
      const map = {
        sku: () => String(a.CODIGO).localeCompare(String(b.CODIGO), 'pt-BR', { numeric: true }),
        produto: () => String(a.DESCRICAO || '').localeCompare(String(b.DESCRICAO || ''), 'pt-BR', { numeric: true }),
        valor: () => (Number(a.VALOR_NOVO) || 0) - (Number(b.VALOR_NOVO) || 0),
        qtd: () => (Number(a.QUANTIDADE_NOVA) || 0) - (Number(b.QUANTIDADE_NOVA) || 0),
      }
      return (map[sortBy] ? map[sortBy]() : 0) * dir
    })
    return rows
  }, [itempedido, search, minQty, sortBy, sortDir])

  const pageCount = Math.max(1, Math.ceil(filteredSorted.length / Number(rowsPerPage || 10)))
  const pageSafe = Math.min(page, pageCount)
  const pageRows = useMemo(() => filteredSorted.slice((pageSafe - 1) * rowsPerPage, pageSafe * rowsPerPage), [filteredSorted, pageSafe, rowsPerPage])

  useEffect(() => { setPage(1) }, [search, minQty, sortBy, sortDir, rowsPerPage])

  /* ── Status ── */
  const currentStep = getStatusStep(pedido?.STATUS)
  const pillStyle = getStatusPillStyle(pedido?.STATUS)

  /* ── Loading inicial ── */
  if (isLoadingOrderData && !pedido_int.length) {
    return (
      <>
        <GlobalStyles />
        <Navbar />
        <div className="od" style={{ paddingTop: 64 }}>
          <div className="od-loading-wrap" style={{ marginTop: 60 }}>
            <div className="od-spin" />
            <span>Carregando pedido...</span>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <GlobalStyles />
      <Navbar />

      <div className="od" style={{ paddingTop: 56 }}>

        {/* ── Cabeçalho sticky ── */}
        <div className="od-header">
          <div className="od-header-left">
            <div className="od-header-icon">
              <Package size={18} color="#2563eb" />
            </div>
            <div>
              <h1 className="od-header-title">
                Pedido <span style={{ color: '#2563eb' }}>#{pedido?.PEDIDO || '...'}</span>
                <button className="od-icon-btn" onClick={() => copy(pedido?.PEDIDO, 'Número copiado!')} title="Copiar número">
                  <Copy size={13} />
                </button>
              </h1>
              <div className="od-header-sub">
                {pedido?.DATA_CONFERENCIA ? fmtDateTime(pedido.DATA_CONFERENCIA) : 'Sem data de conferência'}
              </div>
            </div>
          </div>

          <div className="od-header-right">
            {/* Status pill */}
            <span
              className="od-status-pill"
              style={{ background: pillStyle.bg, color: pillStyle.color, borderColor: pillStyle.border }}
            >
              {pedido?.STATUS || 'Em Processamento'}
            </span>

            <button className="od-btn-sec" onClick={() => fetchOrderData()} title="Atualizar dados">
              <RefreshCw size={13} />
              Atualizar
            </button>

            <button className="od-btn-primary" onClick={() => setShowModalZpl(true)}>
              <Printer size={13} />
              Etiqueta
            </button>
          </div>
        </div>

        <div className="od-body">

          {/* ── Erro ── */}
          {error && (
            <div className="od-error">
              <AlertCircle size={16} />
              {error}
            </div>
          )}

          {/* ── KPIs ── */}
          <div className="od-kpi-grid">
            {[
              { label: 'Canal', value: pedido?.ID_LOJA || '—', icon: Store, iconBg: '#eff6ff', iconColor: '#2563eb' },
              { label: 'Order ID', value: pedido?.IDPEDIDOLOJA ? pedido.IDPEDIDOLOJA.substring(0, 10) + '…' : '—', icon: Receipt, iconBg: '#f0fdf4', iconColor: '#16a34a', copy: pedido?.IDPEDIDOLOJA },
              { label: 'Ship ID', value: pedido?.SHIP || '—', icon: Barcode, iconBg: '#faf5ff', iconColor: '#7c3aed' },
              { label: 'Total de Itens', value: totals.totalQtd.toLocaleString('pt-BR'), icon: PackageSearch, iconBg: '#fffbeb', iconColor: '#b45309' },
              { label: 'Valor Total', value: currencyBRL(totals.totalVlr), icon: TrendingUp, iconBg: '#f0fdf4', iconColor: '#16a34a' },
            ].map((kpi) => (
              <div className="od-kpi" key={kpi.label}>
                <div className="od-kpi-icon" style={{ background: kpi.iconBg }}>
                  <kpi.icon size={16} color={kpi.iconColor} />
                </div>
                <div style={{ minWidth: 0 }}>
                  <div className="od-kpi-label">{kpi.label}</div>
                  <div className="od-kpi-value" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{kpi.value}</span>
                    {kpi.copy && (
                      <button className="od-icon-btn" onClick={() => copy(kpi.copy, `${kpi.label} copiado!`)} style={{ flexShrink: 0 }}>
                        <Copy size={11} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Timeline ── */}
          <div className="od-timeline-card">
            <div style={{ fontSize: 11, fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.05em', marginBottom: 14 }}>
              Andamento do Pedido
            </div>
            <div className="od-timeline-wrap">
              {STATUS_STEPS.map((step, idx) => {
                const done = idx < currentStep
                const active = idx === currentStep
                const Icon = step.icon
                return (
                  <React.Fragment key={step.label}>
                    <div className="od-tl-step">
                      <div className={`od-tl-circle ${done ? 'done' : active ? 'active' : ''}`}>
                        {done ? <CheckCircle2 size={16} /> : <Icon size={16} />}
                      </div>
                      <span className={`od-tl-label ${done ? 'done' : active ? 'active' : ''}`}>{step.label}</span>
                    </div>
                    {idx < STATUS_STEPS.length - 1 && (
                      <div className={`od-tl-line ${done ? 'done' : active ? 'active' : ''}`} />
                    )}
                  </React.Fragment>
                )
              })}
            </div>
          </div>

          {/* ── Layout principal ── */}
          <div className="od-main-grid">

            {/* ── Coluna esquerda ── */}
            <div>

              {/* Filtros */}
              <div className="od-card">
                <div className="od-card-body">
                  <div className="od-filter-bar">
                    <div className="od-search-wrap">
                      <Search size={13} />
                      <input
                        ref={searchRef}
                        type="text"
                        placeholder="Buscar por SKU ou produto..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="od-input"
                      />
                    </div>
                    <div style={{ position: 'relative' }}>
                      <Filter size={13} style={{ position: 'absolute', left: 9, top: '50%', transform: 'translateY(-50%)', color: '#9ca3af', pointerEvents: 'none' }} />
                      <input
                        type="number" min="0" placeholder="Qtd mín."
                        value={minQty} onChange={(e) => setMinQty(e.target.value)}
                        className="od-input od-input-sm" style={{ paddingLeft: 28 }}
                      />
                    </div>
                    <select
                      value={`${sortBy}-${sortDir}`}
                      onChange={(e) => { const [by, dir] = e.target.value.split('-'); setSortBy(by); setSortDir(dir) }}
                      className="od-select"
                    >
                      <option value="produto-asc">Produto A-Z</option>
                      <option value="produto-desc">Produto Z-A</option>
                      <option value="sku-asc">SKU A-Z</option>
                      <option value="sku-desc">SKU Z-A</option>
                      <option value="valor-asc">Menor Valor</option>
                      <option value="valor-desc">Maior Valor</option>
                      <option value="qtd-asc">Menor Qtd</option>
                      <option value="qtd-desc">Maior Qtd</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Itens do pedido */}
              <div className="od-card">
                <div className="od-card-header">
                  <h3 className="od-card-title">
                    <PackageSearch size={14} color="#2563eb" />
                    Itens do Pedido
                    <span className="ob ob-blue" style={{ marginLeft: 4 }}>{filteredSorted.length}</span>
                  </h3>
                  <button className="od-btn-sec" style={{ fontSize: 11, padding: '4px 10px' }} onClick={() => showToast('CSV exportado!')}>
                    <Download size={12} />
                    CSV
                  </button>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className="od-table">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Produto</th>
                        <th className="right">Vlr. Unit.</th>
                        <th className="right">Qtd</th>
                        <th className="right">Total</th>
                        <th className="center" style={{ width: 60 }}>Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pageRows.length > 0 ? pageRows.map((item) => {
                        const kits = kitItemsByRef[item.ID] || []
                        const isOpen = !!openKits[item.ID]
                        return (
                          <React.Fragment key={item.ID}>
                            <tr>
                              <td><span className="od-sku">{item.CODIGO}</span></td>
                              <td>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                  <span style={{ fontSize: 12, fontWeight: 500, color: '#111827' }}>
                                    {(item.DESCRICAO || '').toUpperCase()}
                                  </span>
                                  <span className="ob ob-blue">ANÚNCIO</span>
                                  {kits.length > 0 && (
                                    <span className="ob ob-orange" style={{ cursor: 'pointer' }} onClick={() => toggleKit(item.ID)}>
                                      KIT {kits.length}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="right" style={{ fontWeight: 500 }}>{currencyBRL(Number(item.VALORUNITARIO))}</td>
                              <td className="right" style={{ fontWeight: 600 }}>{Number(item.QUANTIDADE_NOVA || 0).toLocaleString('pt-BR')}</td>
                              <td className="right" style={{ fontWeight: 700, color: '#111827' }}>{currencyBRL(Number(item.VALOR_NOVO))}</td>
                              <td className="center">
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}>
                                  {kits.length > 0 && (
                                    <button className="od-icon-btn" onClick={() => toggleKit(item.ID)} title={isOpen ? 'Recolher kit' : 'Ver composição'}>
                                      {isOpen ? <ChevronDown size={13} /> : <ChevronRight size={13} />}
                                    </button>
                                  )}
                                  <button className="od-icon-btn" onClick={() => copy(item.CODIGO, 'SKU copiado!')} title="Copiar SKU">
                                    <Copy size={12} />
                                  </button>
                                </div>
                              </td>
                            </tr>

                            {/* Composição do kit */}
                            {isOpen && kits.map((kit) => (
                              <tr key={kit.ID} className="kit-row">
                                <td style={{ paddingLeft: 28 }}>
                                  <span className="od-sku" style={{ color: '#6b7280' }}>{kit.CODIGO}</span>
                                </td>
                                <td>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <span style={{ fontSize: 11, color: '#374151' }}>{(kit.DESCRICAO || '').toUpperCase()}</span>
                                    <span className="ob ob-teal">COMPOSIÇÃO</span>
                                  </div>
                                </td>
                                <td className="right" style={{ fontSize: 11, color: '#6b7280' }}>{currencyBRL(Number(kit.VALORUNITARIO))}</td>
                                <td className="right" style={{ fontSize: 11, color: '#6b7280' }}>{Number(kit.QUANTIDADE || 0).toLocaleString('pt-BR')}</td>
                                <td className="right" style={{ fontSize: 11, fontWeight: 600 }}>{currencyBRL(Number(kit.VALOR_NOVO))}</td>
                                <td></td>
                              </tr>
                            ))}
                          </React.Fragment>
                        )
                      }) : (
                        <tr>
                          <td colSpan={6}>
                            <div className="od-empty">
                              <PackageSearch size={32} color="#d1d5db" />
                              <p>Nenhum item encontrado</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>

                    {filteredSorted.length > 0 && (
                      <tfoot>
                        <tr>
                          <td colSpan={3} />
                          <td className="right">
                            <span style={{ color: '#6b7280', fontWeight: 400, fontSize: 11 }}>Total itens: </span>
                            {totals.totalQtd.toLocaleString('pt-BR')}
                          </td>
                          <td className="right">
                            <span style={{ color: '#6b7280', fontWeight: 400, fontSize: 11 }}>Total: </span>
                            {currencyBRL(totals.totalVlr)}
                          </td>
                          <td />
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>

                {/* Paginação */}
                <div className="od-pagination">
                  <span>Página <strong>{pageSafe}</strong> de <strong>{pageCount}</strong> — {filteredSorted.length} itens</span>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <select value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))} className="od-select" style={{ padding: '4px 8px', height: 28 }}>
                      {[10, 20, 50, 100].map((n) => <option key={n} value={n}>{n}/pág</option>)}
                    </select>
                    <div className="od-pag-btns">
                      <button className="od-pag-btn" onClick={() => setPage(1)} disabled={pageSafe <= 1}><ChevronFirst size={13} /></button>
                      <button className="od-pag-btn" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={pageSafe <= 1}><ChevronLeft size={13} /></button>
                      <button className="od-pag-btn" onClick={() => setPage((p) => Math.min(pageCount, p + 1))} disabled={pageSafe >= pageCount}><ChevronRight size={13} /></button>
                      <button className="od-pag-btn" onClick={() => setPage(pageCount)} disabled={pageSafe >= pageCount}><ChevronLast size={13} /></button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Itens conferidos */}
              <div className="od-card">
                <div className="od-card-header">
                  <h3 className="od-card-title">
                    <ClipboardCheck size={14} color="#16a34a" />
                    Itens Conferidos
                    {conferidos.length > 0 && <span className="ob ob-green">{conferidos.length}</span>}
                  </h3>
                </div>
                <div style={{ overflowX: 'auto' }}>
                  <table className="od-table">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Produto</th>
                        <th className="right">Qtd</th>
                        <th className="center">Hora</th>
                        <th className="center">Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      {conferidos.length > 0 ? conferidos.map((item) => (
                        <tr key={item.ID}>
                          <td><span className="od-sku">{item.SKU}</span></td>
                          <td style={{ fontWeight: 500 }}>{(item.DESCRICAO || '').toUpperCase()}</td>
                          <td className="right" style={{ fontWeight: 600 }}>{Number(item.QTDE || 0).toLocaleString('pt-BR')}</td>
                          <td className="center" style={{ color: '#6b7280' }}>{fmtTime(item.HORA_CONF)}</td>
                          <td className="center" style={{ color: '#6b7280' }}>{fmtDate(item.DATA_CONF)}</td>
                        </tr>
                      )) : (
                        <tr>
                          <td colSpan={5}>
                            <div className="od-empty">
                              <ClipboardCheck size={32} color="#d1d5db" />
                              <p>Nenhum item conferido ainda</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Fotos da separação */}
              <div className="od-card">
                <div className="od-card-header">
                  <h3 className="od-card-title">
                    <Camera size={14} color="#b45309" />
                    Fotos da Separação
                  </h3>
                  {fotos.length > 0 && (
                    <span className="ob ob-yellow">{fotos.length} {fotos.length === 1 ? 'foto' : 'fotos'}</span>
                  )}
                </div>
                <div className="od-card-body">
                  {isLoadingFotos ? (
                    <div className="od-loading-wrap" style={{ padding: 30 }}>
                      <div className="od-spin" />
                      <span>Carregando fotos...</span>
                    </div>
                  ) : fotos.length === 0 ? (
                    <div className="od-empty" style={{ padding: 30 }}>
                      <ImageIcon size={32} color="#d1d5db" />
                      <p>Nenhuma foto disponível</p>
                      <p style={{ fontSize: 11, color: '#d1d5db' }}>As fotos aparecerão aqui quando disponíveis</p>
                    </div>
                  ) : (
                    <>
                      <div className="od-photo-grid">
                        {fotos.map((photo, i) => (
                          <div key={i} className="od-photo-thumb" onClick={() => { setCarouselIndex(i); setShowCarousel(true) }}>
                            <img src={`data:image/jpeg;base64,${photo.img}`} alt={`Foto ${i + 1}`}
                              onError={(e) => { e.currentTarget.src = `data:image/png;base64,${photo.img}` }}
                              loading="lazy"
                            />
                            <div className="od-photo-overlay">
                              <Eye size={16} color="white" style={{ opacity: 0.9 }} />
                            </div>
                            <div className="od-photo-num">{i + 1}</div>
                          </div>
                        ))}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 10, fontSize: 11, color: '#9ca3af' }}>
                        <Eye size={11} />
                        Clique para ampliar
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* ── Coluna direita: detalhes ── */}
            <div>

              {/* Dados do pedido */}
              <div className="od-card">
                <div className="od-card-header">
                  <h3 className="od-card-title"><Store size={13} color="#2563eb" />Dados do Pedido</h3>
                </div>
                <div className="od-card-body" style={{ padding: '8px 16px' }}>
                  {[
                    { label: 'Canal de Venda', value: pedido?.ID_LOJA, copy: pedido?.ID_LOJA, mono: false },
                    { label: 'Order ID', value: pedido?.IDPEDIDOLOJA, copy: pedido?.IDPEDIDOLOJA, mono: true },
                    { label: 'Ship ID', value: pedido?.SHIP, mono: true },
                    { label: 'Status', value: pedido?.STATUS, badge: true },
                    { label: 'Impressão', value: pedido?.IMPRESSO === 'S' ? 'Impresso' : 'Não impresso', badge: true, badgeClass: pedido?.IMPRESSO === 'S' ? 'ob-green' : 'ob-gray' },
                  ].map(({ label, value, copy: copyVal, mono, badge, badgeClass }) => (
                    <div className="od-info-row" key={label}>
                      <span className="od-info-label">{label}</span>
                      <span className={`od-info-value${mono ? ' mono' : ''}`}>
                        {badge
                          ? <span className={`ob ${badgeClass || 'ob-blue'}`}>{value || '—'}</span>
                          : (value || '—')
                        }
                        {copyVal && (
                          <button className="od-icon-btn" onClick={() => copy(copyVal, `${label} copiado!`)} style={{ marginLeft: 2 }}>
                            <Copy size={11} />
                          </button>
                        )}
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Dados do cliente */}
              <div className="od-card">
                <div className="od-card-header">
                  <h3 className="od-card-title"><User size={13} color="#16a34a" />Dados do Cliente</h3>
                </div>
                <div className="od-card-body" style={{ padding: '8px 16px' }}>
                  {[
                    { label: 'Nome', value: pedido?.CLIENTE },
                    { label: 'CPF/CNPJ', value: pedido?.CPF, mono: true },
                  ].map(({ label, value, mono }) => (
                    <div className="od-info-row" key={label}>
                      <span className="od-info-label">{label}</span>
                      <span className={`od-info-value${mono ? ' mono' : ''}`} style={{ textAlign: 'right', wordBreak: 'break-word' }}>{value || '—'}</span>
                    </div>
                  ))}
                  <div className="od-info-row" style={{ flexDirection: 'column', gap: 4 }}>
                    <span className="od-info-label">Endereço</span>
                    <span style={{ fontSize: 12, color: '#374151', lineHeight: 1.5 }}>{pedido?.END_ENT || '—'}</span>
                  </div>
                </div>
              </div>

              {/* Dados do conferente */}
              <div className="od-card">
                <div className="od-card-header">
                  <h3 className="od-card-title"><ClipboardCheck size={13} color="#7c3aed" />Conferência</h3>
                </div>
                <div className="od-card-body" style={{ padding: '8px 16px' }}>
                  {[
                    { label: 'Conferente', value: pedido?.CONFERENTE },
                    { label: 'Data/Hora', value: fmtDateTime(pedido?.DATA_CONFERENCIA) },
                    { label: 'Total conferido', value: conferidos.length ? `${conferidos.reduce((a, i) => a + Number(i.QTDE || 0), 0)} itens` : '—' },
                  ].map(({ label, value }) => (
                    <div className="od-info-row" key={label}>
                      <span className="od-info-label">{label}</span>
                      <span className="od-info-value" style={{ textAlign: 'right' }}>{value || '—'}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Expedição */}
              {(pedido?.SHIP_SUBSTATUS || pedido?.DATADESPACHO) && (
                <div className="od-card">
                  <div className="od-card-header">
                    <h3 className="od-card-title"><Truck size={13} color="#b45309" />Expedição</h3>
                  </div>
                  <div className="od-card-body" style={{ padding: '8px 16px' }}>
                    {pedido?.SHIP_SUBSTATUS && (
                      <div className="od-info-row">
                        <span className="od-info-label">Substatus</span>
                        <span className="ob ob-blue">{pedido.SHIP_SUBSTATUS}</span>
                      </div>
                    )}
                    {pedido?.DATADESPACHO && (
                      <div className="od-info-row">
                        <span className="od-info-label">Despacho</span>
                        <span className="od-info-value">{new Date(pedido.DATADESPACHO).toLocaleDateString('pt-BR')}</span>
                      </div>
                    )}
                    {pedido?.BUFFERING_DATE && (
                      <div className="od-info-row">
                        <span className="od-info-label">Etiqueta retida até</span>
                        <span className="ob ob-red">{new Date(pedido.BUFFERING_DATE).toLocaleDateString('pt-BR')}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* ── Carousel de fotos ── */}
        {showCarousel && (
          <div className="od-modal-overlay" onClick={() => setShowCarousel(false)}>
            <button className="od-modal-close" onClick={() => setShowCarousel(false)}><X size={18} /></button>

            <img
              src={`data:image/jpeg;base64,${fotos[carouselIndex]?.img}`}
              alt={`Foto ${carouselIndex + 1}`}
              style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain', borderRadius: 8 }}
              onClick={(e) => e.stopPropagation()}
              onError={(e) => { e.currentTarget.src = `data:image/png;base64,${fotos[carouselIndex]?.img}` }}
            />

            {fotos.length > 1 && (
              <>
                <button className="od-modal-nav left" onClick={(e) => { e.stopPropagation(); setCarouselIndex((p) => p === 0 ? fotos.length - 1 : p - 1) }}>
                  <ChevronLeft size={18} />
                </button>
                <button className="od-modal-nav right" onClick={(e) => { e.stopPropagation(); setCarouselIndex((p) => p === fotos.length - 1 ? 0 : p + 1) }}>
                  <ChevronRight size={18} />
                </button>
              </>
            )}

            <div className="od-modal-counter">{carouselIndex + 1} / {fotos.length}</div>
          </div>
        )}

        {/* ── Modal ZPL ── */}
        {showModalZpl && (
          <div className="od-modal-overlay" onClick={() => setShowModalZpl(false)}>
            <div className="od-zpl-modal" onClick={(e) => e.stopPropagation()}>
              <div className="od-zpl-header">
                <h3>Etiqueta de Envio — #{pedido?.PEDIDO}</h3>
                <button className="od-icon-btn" onClick={() => setShowModalZpl(false)}><X size={16} /></button>
              </div>
              <div className="od-zpl-body">
                <ZPLRenderer zpl={zpl} />
              </div>
              <div className="od-zpl-footer">
                <button className="od-btn-sec" onClick={() => setShowModalZpl(false)}>Fechar</button>
                <button className="od-btn-primary"><Printer size={13} />Imprimir</button>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast.show && (
          <div className={`od-toast ${toast.variant}`}>
            {toast.variant === 'success' && <CheckCircle2 size={14} />}
            {toast.variant === 'danger' && <AlertCircle size={14} />}
            {toast.msg}
          </div>
        )}
      </div>
    </>
  )
}

export default OrderDetails